import { NextPage } from 'next'
import Head from 'next/head'
import PageHeader from '@components/PageHeader'
import { Layout, ImagesGrid, TextBlock } from '@components/work'
import Button from '@components/Button'

const ForMobilePage: NextPage = () => (
  <>
    <Head>
      <title>Work - Formobile</title>
    </Head>

    <PageHeader
      title={[['Formobile']]}
      subtitle={[
        ['an end-to-end', 'forensic', 'investigation'],
        ['chain for', 'mobile devices.'],
      ]}
    />

    <Layout>
      <ImagesGrid
        images={[
          { src: '/images/work/for-mobile/01.jpg', alt: '' },
          { src: '/images/work/for-mobile/02.jpg', alt: '' },
        ]}
      />

      <TextBlock>
        <p>
          The website is a platform created for European law enforcement
          authorities. It allows them to acquire and share knowledge in the
          field of all kinds of investigations.
        </p>

        <p>
          A dedicated section specially designed for this purpose has been
          secured with a multi-factor authentication method (in this case with
          the 2FA standard). The site includes a blog, an event calendar and a
          public file repository.
        </p>

        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://formobile-project.eu/"
          className="d-inline-block"
        >
          <Button theme="red-outline" text="Check it out" />
        </a>
      </TextBlock>

      <ImagesGrid
        images={[
          { src: '/images/work/for-mobile/03.jpg', alt: '' },
          { src: '/images/work/for-mobile/04.jpg', alt: '' },
        ]}
      />
    </Layout>
  </>
)

export default ForMobilePage
